/* eslint-disable */
import React, { ChangeEvent, memo, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import UserSettings from '../../models/UserSettings';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { InputLabel } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import srv from '../../services';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { TooltipProps, Typography } from '@mui/material';
import { useMutation } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';
import { smsQuery } from '../../services/appolo/smsQuery';
import { cloneDeep } from 'lodash';
import { Buffer } from 'buffer';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    justifyItems: 'center',
    textAlign: 'center',
    color: (props: UserSettings) => props.color,
    border: '5px white solid',
    margin: 'auto',
    borderRadius: '5px',
    minHeight: '600px',
    overflow: 'auto',
    '& .MuiOutlinedInput-input': {
      textAlign: 'center',
      color: '#4551D1',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4551D1',
      color: '#4551D1',
      WebkitAppearance: 'none',
    },
    '& .MuiInputLabel-root': {
      color: '#4551D1',
    },
    '& .MuiSvgIcon-root': {
      color: '#4551D1',
    },
    height: 'auto',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 20px)',
      margin: 'auto',
      '& .MuiInputBase-root': {
        fontSize: '12px !important',
        width: '60%',
        height: '100px !important',
      },
      '& .MuiTextField-root': {
        height: '60px !important',
        fontSize: '12px !important',
        width: '80%  !important',
        margin: 'auto',
        WebkitAppearance: 'none',
      },
      '& .MuiOutlinedInput-root': {
        height: '60px !important',
        fontSize: '16px !important',
        width: '100%  !important',
        margin: 'auto',
      },
      '& .MuiInputLabel-root': {
        fontSize: '16px !important',
        margin: 'auto',
      },
      '& .MuiButton-root': {
        marginTop: '15px',
        width: '80% !important',
        fontSize: '16px !important',
        height: '60px !important',
        backgroundColor: '#4551D1',
        borderRadius: '5px',
        fontWeight: 800,
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
    [theme.breakpoints.up(600)]: {
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 20px)',
      margin: 'auto',
      '& .MuiInputBase-root': {
        fontSize: '12px !important',
        width: '60%',
        height: '100px !important',
      },
      '& .MuiTextField-root': {
        height: '60px !important',
        fontSize: '12px !important',
        width: '70%  !important',
        margin: 'auto',
        WebkitAppearance: 'none',
      },
      '& .MuiOutlinedInput-root': {
        height: '60px !important',
        fontSize: '24px !important',
        width: '100%  !important',
        margin: 'auto',
      },
      '& .MuiInputLabel-root': {
        fontSize: '16px !important',
        margin: 'auto',
        marginLeft: '10px',
        marginTop: '-3px',
      },
      '& .MuiButton-root': {
        marginTop: '20px',
        width: '70% !important',
        fontSize: '20px !important',
        height: '60px !important',
        backgroundColor: '#4551D1',
        borderRadius: '5px',
        fontWeight: 800,
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
    [theme.breakpoints.up(800)]: {
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 20px)',
      margin: 'auto',
      '& .MuiInputBase-root': {
        fontSize: '12px !important',
        width: '60%',
        height: '100px !important',
      },
      '& .MuiTextField-root': {
        height: '60px !important',
        fontSize: '12px !important',
        width: '70%  !important',
        margin: 'auto',
        WebkitAppearance: 'none',
      },
      '& .MuiOutlinedInput-root': {
        height: '60px !important',
        fontSize: '24px !important',
        width: '100%  !important',
        margin: 'auto',
      },
      '& .MuiInputLabel-root': {
        fontSize: '23px !important',
        margin: 'auto',
        marginLeft: '10px',
        marginTop: '-3px',
      },
      '& .MuiButton-root': {
        marginTop: '20px',
        width: '70% !important',
        fontSize: '20px !important',
        height: '60px !important',
        backgroundColor: '#4551D1',
        borderRadius: '5px',
        fontWeight: 800,
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
    [theme.breakpoints.up(1200)]: {
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 20px)',
      margin: 'auto',
      '& .MuiInputBase-root': {
        fontSize: '12px !important',
        width: '60%',
        height: '100px !important',
      },
      '& .MuiTextField-root': {
        height: '60px !important',
        fontSize: '12px !important',
        width: '40%  !important',
        margin: 'auto',
        WebkitAppearance: 'none',
      },
      '& .MuiOutlinedInput-root': {
        height: '60px !important',
        fontSize: '24px !important',
        width: '100%  !important',
        margin: 'auto',
      },
      '& .MuiInputLabel-root': {
        fontSize: '23px !important',
        margin: 'auto',
        marginLeft: '10px',
        marginTop: '-3px',
      },
      '& .MuiButton-root': {
        marginTop: '20px',
        width: '40% !important',
        fontSize: '20px !important',
        height: '60px !important',
        backgroundColor: '#4551D1',
        borderRadius: '5px',
        fontWeight: 800,
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
    [theme.breakpoints.up(1400)]: {
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 20px)',
      margin: 'auto',
      '& .MuiInputBase-root': {
        fontSize: '12px !important',
        width: '60%',
        height: '100px !important',
      },
      '& .MuiTextField-root': {
        height: '60px !important',
        fontSize: '12px !important',
        width: '30%  !important',
        margin: 'auto',
        WebkitAppearance: 'none',
      },
      '& .MuiOutlinedInput-root': {
        height: '60px !important',
        fontSize: '24px !important',
        width: '100%  !important',
        margin: 'auto',
      },
      '& .MuiInputLabel-root': {
        fontSize: '23px !important',
        margin: 'auto',
        marginLeft: '10px',
        marginTop: '-3px',
      },
      '& .MuiButton-root': {
        marginTop: '20px',
        width: '30% !important',
        fontSize: '20px !important',
        height: '60px !important',
        backgroundColor: '#4551D1',
        borderRadius: '5px',
        fontWeight: 800,
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
  },

  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },

  divErrorBlock: {
    [theme.breakpoints.down('sm')]: {
      width: '80%  !important',
      fontSize: '24px !important',
    },
    [theme.breakpoints.up(600)]: {
      width: '70%  !important',
      fontSize: '24px !important',
    },
    [theme.breakpoints.up(800)]: {
      width: '70%  !important',
      fontSize: '24px !important',
    },
    [theme.breakpoints.up(1200)]: {
      width: '40%  !important',
      fontSize: '24px !important',
    },
    [theme.breakpoints.up(1400)]: {
      width: '30%  !important',
      fontSize: '24px !important',
    },
  },

  image: {
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      textAlign: 'center',
      marginBottom: '10% !important',
      width: (props: UserSettings) => (props.isVostokLogo ? '30%' : '50%'),
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      textAlign: 'center',
      marginBottom: '10% !important',
      width: (props: UserSettings) => (props.isVostokLogo ? '50%' : '60%'),
    },
    [theme.breakpoints.up(600)]: {
      height: 'auto',
      textAlign: 'center',
      marginBottom: '5% !important',
      width: (props: UserSettings) => (props.isVostokLogo ? '30%' : '50%'),
    },
    [theme.breakpoints.up(800)]: {
      height: 'auto',
      textAlign: 'center',
      marginBottom: '5% !important',
      width: (props: UserSettings) => (props.isVostokLogo ? '25%' : '50%'),
    },
    [theme.breakpoints.up(1200)]: {
      height: 'auto',
      textAlign: 'center',
      marginBottom: '5% !important',
      width: (props: UserSettings) => (props.isVostokLogo ? '25%' : '40%'),
    },
    [theme.breakpoints.up(1400)]: {
      height: 'auto',
      textAlign: 'center',
      marginBottom: '5% !important',
      width: (props: UserSettings) => (props.isVostokLogo ? '20%' : '20%'),
    },
  },
  typography: {
    borderRadius: '5px',
    width: '80%',
    marginTop: '-130px',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '6px !important',
      fontWeight: 600,
      color: 'black !important',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '24px !important',
      fontWeight: 800,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '24px !important',
      fontWeight: 800,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '24px !important',
      fontWeight: 800,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '24px !important',
      fontWeight: 800,
    },
  },
  vostok: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '10% !important',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '10% !important',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '10% !important',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '1% !important',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '1% !important',
    },
  },
  vostokText: {
    fontSize: '12px !important',
    color: '#4551D1 !important',
  },
  errorStyle: {
    marginTop: '5px !important',
    color: 'red',
    fontWeight: 600,
    fontFamily: 'Calibri (Body)',
    fontStyle: 'italic',
    fontSize: '12px !important',
  },
  errorStyleSecondLine: {
    color: 'red',
    fontWeight: 600,
    fontFamily: 'Calibri (Body)',
    fontStyle: 'italic',
    fontSize: '12px !important',
  },
}));

// const getPull = async () => {
//   const base64toBlob = (data: string) => {
//     if (!data) {
//       return new Blob();
//     }

//     let base64WithoutPrefix = '';
//     let docType = '';

//     base64WithoutPrefix = data;

//     if (data.indexOf('data:application/pdf;base64,') !== -1) {
//       base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);
//     }

//     docType = 'application/pdf';

//     try {
//       const bytes = atob(base64WithoutPrefix);
//       let length = bytes.length;
//       let out = new Uint8Array(length);

//       while (length--) {
//         out[length] = bytes.charCodeAt(length);
//       }

//       return new Blob([out], { type: docType });
//     } catch (e: any) {
//       console.log('error');
//       return null;
//     }
//   };

//   const response = await fetch('https://dolg-dev.vostok-electra.ru/publicgateway/graphql ', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       operationName: 'smsQuery',
//       query: `
//       query smsQuery {
//         getFile(token: "00000F", accountNumber: "1234567890") {
//           file
//           error {
//             code
//             message
//             __typename
//           }
//           __typename
//         }
//       }
//     `,
//     }),
//   });

//   const result = await response.json();

//   const blob: any = base64toBlob(result.data.getFile.file);

//   const a = document.createElement('a');
//   a.href = URL.createObjectURL(blob);
//   a.download = 'Копия заявления в суд.pdf';
//   //a.download = url.split('/').pop();
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);

//   console.log(result.data);
// };

const DebtorDocumentForm = () => {
  const userSettings = useSelector((state: RootState) => state.getUserSettings, shallowEqual);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const region = params.get('region');
  const token = params.get('token');

  const [accountNumber, setAccountNumber] = useState('');
  const [executeAccountNumber, setExecuteAccountNumber] = useState<string | null>(null);

  const [errorMessage, setErrorMessage] = useState(!token || !region ? 'Неверные данные' : '');
  const [clickCounter, setClickCounter] = useState<number>(0);
  const [errorMessageSecondLine, setErrorMessageSecondLine] = useState<string | undefined>('');

  const userSettingsParams = cloneDeep(userSettings);
  userSettingsParams.isVostokLogo = true;

  const phonwNumberRic = process.env.REACT_APP_SUPPORT_PHONE_RIC;
  const phonwNumberUric = process.env.REACT_APP_SUPPORT_PHONE_URIC;
  const phonwNumberEric = process.env.REACT_APP_SUPPORT_PHONE_ERIC;

  let phoneNumberResult = phonwNumberEric;

  let regionName = '../../../../vostok.png';
  phoneNumberResult = phonwNumberRic;

  if (region?.toLowerCase() === 'юриц') {
    regionName = '../../../../uric.png';
    userSettingsParams.isVostokLogo = false;
    phoneNumberResult = phonwNumberUric;
  }

  if (region?.toLowerCase() === 'ериц') {
    regionName = '../../../../eric.png';
    userSettingsParams.isVostokLogo = false;
    phoneNumberResult = phonwNumberEric;
  }

  if (region?.toLowerCase() === 'риц') {
    regionName = '../../../../ric-logo.png';
    userSettingsParams.isVostokLogo = false;
    phoneNumberResult = phonwNumberRic;
  }

  const classes = useStyles(userSettingsParams);
  const dispatch = useDispatch<AppDispatch>();

  const handleAccountNumberChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    e.preventDefault();
    const value = e?.target?.value;

    if (value && Number(value) < 0) {
      return accountNumber;
    }

    if (value && value.length > 20) {
      const newValue = value.substring(0, 20);
      setAccountNumber(newValue);
      return;
    }

    setAccountNumber(value);
  };

  const userToken = useSelector((state: RootState) => state.userToken, shallowEqual as any);

  const payloadSms = {
    query: smsQuery,
    token: token,
    accountNumber: executeAccountNumber,
  };

  let [refetchSms, { loading: smsLoading, error: smsError, data: smsData }] = useLazyQuery(
    payloadSms.query(payloadSms),
    {
      context: {
        headers: {
          authorization: `Bearer ${userToken}`,
        },
      },
      fetchPolicy: 'no-cache',
    }
  );

  const base64toBlob = (data: string) => {
    if (!data) {
      return new Blob();
    }

    let base64WithoutPrefix = '';
    let docType = '';

    base64WithoutPrefix = data;

    if (data.indexOf('data:application/pdf;base64,') !== -1) {
      base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);
    }

    docType = 'application/pdf';

    try {
      const bytes = atob(base64WithoutPrefix);
      let length = bytes.length;
      let out = new Uint8Array(length);

      while (length--) {
        out[length] = bytes.charCodeAt(length);
      }

      return new Blob([out], { type: docType });
    } catch (e: any) {
      console.log('error');
      return null;
    }
  };

  useEffect(() => {
    // setExecuteAccountNumber(cloneDeep(accountNumber))
    if (!accountNumber) {
      return;
    }

    const fetchWithTimeout = async () => {
      try {
        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Превышено время ожидания ответа')), 10000)
        );

        const response: any = await Promise.race([refetchSms(), timeoutPromise]);

        if (response && response?.data?.getFile && response?.data?.getFile?.file) {
          setErrorMessage('');
          setErrorMessageSecondLine('');

          const blob: any = base64toBlob(response.data.getFile.file);

          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'Копия заявления в суд.pdf';
          //a.download = url.split('/').pop();
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          if (response?.data?.getFile?.error?.message) {
            setErrorMessage(
              response.data.getFile.error.message.replace(
                'Слишком много попыток. Попробуйте через',
                'Много попыток. Попробуйте через'
              )
            );
            setErrorMessageSecondLine(phoneNumberResult);
          }
        }
      } catch (err: any) {
        setErrorMessage('Сервер не отвечает. Попробуйте позже');
        setErrorMessageSecondLine(phoneNumberResult);
      }
    };

    fetchWithTimeout();
  }, [executeAccountNumber]);

  const getDocument = () => {
    setExecuteAccountNumber(cloneDeep(accountNumber));
  };

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'white',
      width: '100%',
      fontSize: theme.typography.pxToRem(12),
    },
  }));

  return (
    <div className={classes.container}>
      <div
        style={{
          textAlign: 'center',
          border: '5px white solid',
        }}
      >
        <div>
          <img className={classes.image} src={regionName} alt="Восток Софт" />
        </div>
        <div>
          {/* <HtmlTooltip
      sx={{
       borderRadius: '5px',
       backgroundColor: 'white',
       marginTop: '-10px',
       display: 'flex',
       flexDirection: 'column',
       alignContent: 'center',
       alignItems: 'center',
       justifyContent: 'center',
       width: '10%',
       fontSize: '24px',
      }}
      title={
       <Typography className={classes.typography} color="inherit">
        <label
         style={{
          fontSize: '12px',
          color: 'black',
          border: '1px grey solid',
          padding: '5px',
          backgroundColor: 'white',
          width: '500%',
         }}
        >
         Введите номер лицевого счета
        </label>
       </Typography>
      }
     > */}
          <TextField
            className={classes.input}
            sx={{ borderColor: 'red !important' }}
            disabled={false}
            InputLabelProps={{
              shrink: true,
              style: { fontSize: '16px !important' },
            }}
            //  InputProps={{
            //   inputProps: { min: 4, max: 4 },
            //  }}
            size={'small'}
            type="number"
            inputMode="numeric"
            label="Введите номер лицевого счета"
            placeholder="Номер лицевого счета"
            onChange={(e) => handleAccountNumberChange(e)}
            focused={true}
            value={accountNumber}
            autoFocus
          />
          {/* </HtmlTooltip> */}
        </div>
        <div
          style={{
            textAlign: 'center',
            margin: 'auto',
            marginBottom: '3%',
            overflow: 'hidden',
          }}
        >
          {/* <HtmlTooltip
      sx={{
       borderRadius: '5px',
       backgroundColor: 'white',
       marginTop: '-10px',
       display: 'flex',
       flexDirection: 'column',
       alignContent: 'center',
       alignItems: 'center',
       justifyContent: 'center',
       width: '10%',
      }}
      title={
       <Typography className={classes.typography} color="inherit">
        <label
         style={{
          color: 'black',
          border: '1px grey solid',
          padding: '5px',
          backgroundColor: 'white',
          width: '600%',
         }}
        >
         Нажмите, чтобы получить документ
        </label>
       </Typography>
      }
     > */}
          <Button
            variant="outlined"
            onClick={() => getDocument()}
            disabled={accountNumber.length < 3 || clickCounter >= 5}
            style={{
              backgroundColor: accountNumber.length < 3 || clickCounter >= 5 ? 'white' : '#4551D1',
              cursor: accountNumber.length < 3 ? 'default' : 'pointer',
              color: accountNumber.length < 3 && clickCounter < 5 ? '#4551D1' : 'white',
              fontWeight: accountNumber.length < 3 ? 200 : 700,
              border: '2px #4551D1 solid',
            }}
          >
            Получить документ
          </Button>
          {/* </HtmlTooltip> */}

          <div
            style={{
              margin: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              justifyItems: 'center',
              textAlign: 'left',
              alignContent: 'flex-start',
              alignItems: 'flex-start',
              paddingLeft: '10px',
              whiteSpace: 'pre-line',
            }}
            className={classes.divErrorBlock}
          >
            <label className={classes.errorStyle}>{errorMessage}</label>
            <label className={classes.errorStyleSecondLine}>{errorMessageSecondLine}</label>
          </div>
        </div>

        {/* <Button onClick={getPull}>test</Button> */}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            justifyItems: 'center',
          }}
        >
          <div
            className={classes.vostok}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              justifyItems: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
          >
            <CopyrightIcon style={{ width: '24px', height: '24px' }} />
            <label style={{ marginLeft: '5px', width: '100%' }} className={classes.vostokText}>
              Восток.Софт
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(DebtorDocumentForm);